import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import CSP from "./pages/CSP";
import CoveredCalls from "./pages/CoveredCalls";
import Wheel from "./pages/Wheel";
import Glossary from "./pages/Glossary";
import Analogies from "./pages/Analogies";
import FAQs from "./pages/FAQs";
import MathRisk from "./pages/MathRisk";
import TeachingKits from "./pages/TeachingKits";
import Disclaimers from "./pages/Disclaimers";
import About from "./pages/About";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/csp" element={<CSP />} />
            <Route path="/covered-calls" element={<CoveredCalls />} />
            <Route path="/wheel" element={<Wheel />} />
            <Route path="/glossary" element={<Glossary />} />
            <Route path="/analogies" element={<Analogies />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/math-risk" element={<MathRisk />} />
            <Route path="/teaching-kits" element={<TeachingKits />} />
            <Route path="/disclaimers" element={<Disclaimers />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            {/* 404 Catch-All Route - Must be last */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
